import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LivekitService } from '../../core/services/livekit.service';
import { ChatPage } from '../../shared/chat-page/chat-page';

@Component({
  selector: 'app-panelist',
  imports: [ChatPage],
  templateUrl: './panelist.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Panelist implements OnInit {
  private readonly livekit = inject(LivekitService);
  private readonly destroyRef = inject(DestroyRef);

  readonly isConnecting = signal(false);

  ngOnInit(): void {
    this.connect();
  }

  connect(): void {
    if (this.isConnecting()) return;
    this.isConnecting.set(true);
    this.livekit
      .connect({ role: 'panelist', participantName: 'Panelist' })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({ complete: () => this.isConnecting.set(false) });
  }
}
